/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/**
 * Defines the Design Language System (DLS) Material Exception Icon component.
 */
export const MaterialExceptionIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M12.7 12.7H10.5V6.3H12.6L12.7 12.7ZM10.5 14.8H12.6V16.9H10.5V14.8ZM15.6 2H7.6L2 7.6V15.6L7.6 21.2H15.6L21.2 15.6V7.6L15.6 2Z' fill={iconColor} />
    </svg>
  );
};

export default MaterialExceptionIcon;
